module.exports = __webpack_public_path__ + "img/avatar_default_8.e8bbd44d.svg";